import type { CoreApiClient } from "../client";
import type { PatchBuildingRoomsRequestBody, PostBuildingRoomsRequestBody, Room } from "../types";

export const createRoomMutations = (api: CoreApiClient) => {
  const { request } = api;

  const deleteRoom = async (roomId: string): Promise<void> => {
    await request("delete", "/rooms/{roomId}", {
      params: { path: { roomId } },
    });
  };

  const create = async (buildingId: string, body: PostBuildingRoomsRequestBody): Promise<Room[]> => {
    const { data } = await request("post", "/buildings/{buildingId}/rooms", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  const update = async (buildingId: string, body: PatchBuildingRoomsRequestBody): Promise<Room[]> => {
    const { data } = await request("patch", "/buildings/{buildingId}/rooms", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  return {
    delete: deleteRoom,
    create,
    update,
  };
};
